export const DialogLegalTransactionTypeMapping = {
  CompanyFoundation: 1,
  CompanyChange: 2,
  RegisteredAssociationFoundation: 3,
  RegisteredAssociationChange: 4,
  Inherit: 5,
  Purchase: 6,
  Mortgage: 7,
  SignatureCertification: 8,
  LandRegisterQuery: 9,
  Testament: 10,
  General: 12,
} as const;

export type DialogLegalTransactionType =
  keyof typeof DialogLegalTransactionTypeMapping;
